import * as z from 'zod';

import { fileQuerySchema } from '@/_schemas/file';
import { paginatedResponseSchema } from '@/_schemas/generic/paginated-response';
import { statusQuerySchema } from '@/_schemas/status-input';

export const bdQuerySchema = z.object({
  id: z.number(),
  name: z.string(),
  abbreviation: z.string().nullable(),
  status: statusQuerySchema,
  logo_dark: z.array(fileQuerySchema).nullish(),
  logo_light: z.array(fileQuerySchema).nullish(),
});

export type BdQuerySchema = z.infer<typeof bdQuerySchema>;

export const bdQueryAllSchema = paginatedResponseSchema(bdQuerySchema);

export type BdQueryAllSchema = z.infer<typeof bdQueryAllSchema>;
